import { graphql } from 'gql';

export const uerWorkOrderPriceListRatioForRootObject = graphql(`
    query uerWorkOrderPriceListRatioForRootObject(
        $skip: Int
        $take: Int
        $workOrderObjectId: Long!
        $where: WorkOrderPriceRatioRowDataFilterInput
        $order: [WorkOrderPriceRatioRowDataSortInput!]
    ) {
        uerWorkOrderPriceListRatioForRootObject(
            skip: $skip
            take: $take
            workOrderObjectId: $workOrderObjectId
            where: $where
            order: $order
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                code
                groupId
                groupName
                id
                isIncludedInAct
                isIncludedInWorkOrder
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                ratioType
                status
                workConditions
            }
        }
    }
`);

export const uerWorkOrderPriceListRatioForObjects = graphql(`
    query uerWorkOrderPriceListRatioForObjects(
        $skip: Int
        $take: Int
        $workOrderObjectIds: [Long!]!
        $where: WorkOrderPriceRatioRowDataFilterInput
        $order: [WorkOrderPriceRatioRowDataSortInput!]
    ) {
        uerWorkOrderPriceListRatioForObjects(
            skip: $skip
            take: $take
            workOrderObjectIds: $workOrderObjectIds
            where: $where
            order: $order
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                code
                groupId
                groupName
                id
                isIncludedInAct
                isIncludedInWorkOrder
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                ratioType
                status
                workConditions
            }
        }
    }
`);

export const uerWorkOrderChangePriceListRatioForRootObject = graphql(`
    query uerWorkOrderChangePriceListRatioForRootObject(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $rootObjectIds: WorkOrderChangeObjectIdInput!
        $where: WorkOrderPriceRatioRowDataFilterInput
        $order: [WorkOrderPriceRatioRowDataSortInput!]
    ) {
        uerWorkOrderChangePriceListRatioForRootObject(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            rootObjectIds: $rootObjectIds
            where: $where
            order: $order
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                code
                groupId
                groupName
                id
                isIncludedInAct
                isIncludedInWorkOrder
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                ratioStatus
                ratioType
                status
                workConditions
            }
        }
    }
`);

export const uerWorkOrderChangePriceListRatioForObjects = graphql(`
    query uerWorkOrderChangePriceListRatioForObjects(
        $skip: Int
        $take: Int
        $workOrderChangeId: Long!
        $constructionTypeId: Int!
        $objectIds: [WorkOrderChangeObjectIdInput!]!
        $where: WorkOrderPriceRatioRowDataFilterInput
        $order: [WorkOrderPriceRatioRowDataSortInput!]
    ) {
        uerWorkOrderChangePriceListRatioForObjects(
            skip: $skip
            take: $take
            workOrderChangeId: $workOrderChangeId
            constructionTypeId: $constructionTypeId
            objectIds: $objectIds
            where: $where
            order: $order
        ) {
            totalCount
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                code
                groupId
                groupName
                id
                isIncludedInAct
                isIncludedInWorkOrder
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                ratioStatus
                ratioType
                status
                workConditions
            }
        }
    }
`);
